import { of, from } from 'rxjs';
import { take, tap, switchMap, mapTo } from 'rxjs/operators';
import { ContentProvider } from '@awp/content';
import { ThemeLoaderService } from '@awp/theme';
import { isNullOrEmpty } from '@awp/core/utils';
import * as i0 from "@angular/core";
import * as i1 from "../../../../content/src/lib/content.provider";
import * as i2 from "../../../../theme/src/lib/theme-loader.service";
var RootThemeResolver = /** @class */ (function () {
    function RootThemeResolver(contentProvider, themeLoader) {
        this.contentProvider = contentProvider;
        this.themeLoader = themeLoader;
    }
    RootThemeResolver.prototype.resolve = function () {
        var _this = this;
        return this.contentProvider.fetchRoot().pipe(take(1), tap(function (p) {
            if (!isNullOrEmpty(p.pageTitle)) {
                _this.themeLoader.setTitle(p.pageTitle);
            }
            if (p.favIcon != null) {
                _this.themeLoader.setFavIcon(p.favIcon.href);
            }
        }), switchMap(function (p) {
            if (p.theme != null) {
                return from(_this.themeLoader.setCssNode('theme-css', p.theme.href))
                    .pipe(mapTo(p));
            }
            return of(p);
        }));
    };
    RootThemeResolver.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function RootThemeResolver_Factory() { return new RootThemeResolver(i0.ɵɵinject(i1.ContentProvider), i0.ɵɵinject(i2.ThemeLoaderService)); }, token: RootThemeResolver, providedIn: "root" });
    return RootThemeResolver;
}());
export { RootThemeResolver };
